export const IMAGE_PUBLIC_PATH = "/images";
export const GIF_PUBLIC_PATH = "/gifs";
